"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _resources = require("./resources");
Object.keys(_resources).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _resources[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _resources[key];
    }
  });
});